<template>
    <div class="date-range" :class="{'opened': opened === true}">
        <div class="date-backdrop" v-if="opened === true" @click="opened = false"></div>
        <div class="date-range-label" @click="opened = !opened">
            <span v-if="value !== null">{{format(value)}}</span>
            <span v-if="value !== null && valueTo !== null">-</span>
            <span v-if="valueTo !== null">{{format(valueTo)}}</span>
            <span class="data-range-empty" v-if="value === null && valueTo === null">{{t('Search here')}}</span>
        </div>
        <div class="date-range-window" v-if="opened === true">
            <label class="form-label mb-1 d-block">{{'Date from'}}</label>
            <datepicker :value="value"
                        format="dd.MM.yyyy"
                        :monday-first="true"
                        :bootstrap-styling="true"
                        :highlighted="highlighted"
                        v-on:selected="updateValue"
                        v-on:cleared="updateValue"
                        v-on:input="updateValue"
            ></datepicker>
            <label class="form-label mt-2 mb-1 d-block">{{'Date to'}}</label>
            <datepicker :value="valueTo"
                        format="dd.MM.yyyy"
                        :monday-first="true"
                        :bootstrap-styling="true"
                        :highlighted="highlighted"
                        v-on:selected="updateValueTo"
                        v-on:cleared="updateValueTo"
                        v-on:input="updateValueTo"
            ></datepicker>
            <div class="date-range-footer mt-2">
                <button type="button" class="btn btn-primary btn-sm" @click="opened = false">
                    <font-awesome-icon icon="check"/>
                    {{t('Apply')}}
                </button>
                <button type="button" class="btn btn-danger btn-sm" @click="reset()">
                    <font-awesome-icon icon="times"/>
                    {{t('Reset')}}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import moment from 'moment';

    export default {
        components: {
            Datepicker
        },
        props: {
            settings: {
                type: Object,
                required: true
            }
        },
        computed: {
            labelFormat() {
                return this.settings.labelFormat === undefined ?  'DD.MM.YY' : this.settings.labelFormat;
            },
            inputFormat() {
                return this.settings.inputFormat === undefined ?  'YYYY-MM-DD' : this.settings.inputFormat;
            }
        },
        methods: {
            format(date) {
                return moment(date, this.inputFormat).format(this.labelFormat);
            },
            reset() {
                this.value = null;
                this.valueTo = null;
                this.opened = false;
                this.emitChange();
            },
            updateValue(date) {
                const momentDate = moment.utc(date);
                this.value = date === null ? null : momentDate.format(this.inputFormat);
                if (this.valueTo !== null && momentDate > moment(this.valueTo, this.inputFormat)) {
                    this.valueTo = null;
                }
                this.emitChange();
            },
            updateValueTo(date) {
                const momentDate = moment.utc(date);
                this.valueTo = date === null ? null : momentDate.format(this.inputFormat);
                if (this.value !== null && momentDate < moment(this.value, this.inputFormat)) {
                    this.value = null;
                }
                this.emitChange();
            },
            emitChange() {
                this.$emit('change', {
                    value: this.value,
                    valueTo: this.valueTo
                });
            }
        },
        data() {
            return {
                opened: false,
                value: null,
                valueTo: null,
                highlighted: {
                    dates: [
                        new Date()
                    ]
                }
            }
        }
    }
</script>
<style lang="scss">
    $primaryColor: #009DFA ! default;
    $secondaryText: #ffffff ! default;

    .date-range {
        position: relative;

        .date-backdrop {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 9999;
            cursor: pointer;
        }

        &.opened:after {
            content: ' ';
            position: absolute;
            top: 100%;
            height: 3px;
            background: #3ac165;
            left: -6px;
            right: -6px;
            margin-top: 4px;
        }

        .date-range-label {
            line-height: 31px;
            font-size: 14px;
            cursor: pointer;
            padding-left: 6px;
            position: relative;

            .data-range-empty {
                color: #dbdbdb;
            }
        }

        .date-range-window {
            position: absolute;
            top: 100%;
            margin-top: 5px;
            left: -6px;
            width: 200px;
            z-index: 10000;
            background: #fff;
            border: 1px solid #e8eaed;
            -webkit-box-shadow: 5px 5px 25px 0px rgba(0, 0, 0, 0.07);
            -moz-box-shadow: 5px 5px 25px 0px rgba(0, 0, 0, 0.07);
            box-shadow: 5px 5px 25px 0px rgba(0, 0, 0, 0.07);
            padding: 10px;

            .form-control {
                background: #fff;
                border: 1px solid #e8eaed ! important;
            }
        }

        .calendar-icon {
            position: absolute;
            right: 10px;
            z-index: 10;
            top: 10px;
            color: #8a8a8a;
        }

        .vdp-datepicker {
            .form-control {
                background: #fff;
                cursor: pointer;
            }
        }

        .vdp-datepicker__calendar {
            border-color: $primaryColor ! important;
            width: 247px ! important;
            border-radius: 4px;

            header {
                > span {
                    background: darken($primaryColor, 5%);
                    color: $secondaryText;

                    &:hover {
                        background: darken($primaryColor, 8%) ! important;
                    }
                }

                .prev:after {
                    border-right-color: $secondaryText ! important;
                }

                .next:after {
                    border-left-color: $secondaryText ! important;
                }
            }

            .day-header {
                background: $primaryColor;
                color: $secondaryText;
                margin-bottom: 2px;

                &:hover {
                    background: $primaryColor ! important;
                }
            }

            .cell {
                height: 35px ! important;
                line-height: 35px ! important;
                font-size: 0.8rem;

                &.highlighted {
                    border-radius: 3px;
                }

                &.selected {
                    border-radius: 3px;
                    background: $primaryColor ! important;
                    color: $secondaryText;
                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/core/InlineDataGrid/filters/DateRange.vue